const cinternoitems = {

  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",

  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],

  pdfs: [
    {
      id: 1,
      tituloTexto: "Marco Integrado de Control Interno",
      descripcion: "Como parte de las funciones del Control Interno en la Secretaría de Bienestar e Inclusión Social. El presente documento denominado Marco Integrado de Control Interno de la Auditoria Superior de la Federación (ASF), es adoptado y adaptado de las normativas COSO (Committee of Sponsoring Organizations of the Treadway Commission) y aplicadas a las necesidades de la Administración Pública.",
      tituloPdf: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Marco_Integrado_de_Cont_Int_leyen.pdf"
    },
    {
      id: 2,
      tituloTexto: "Modelo Estatal de Marco Integrado de Control Interno para el Sector Público del Estado de Hidalgo",
      descripcion: "Como parte de actividades de Control Interno del ámbito Federal el Gobierno del Estado de Hidalgo emite las Disposiciones y el Manual Administrativo de Aplicación Estatal en Materia de Control Interno y el Modelo Estatal de Marco Integrado de Control Interno para el Sector Publicó del Estado de Hidalgo para que las instituciones en el ámbito estatal adopten y adapten dicho documento, con el objetivo de identificar áreas de oportunidad e integrar acciones para una eficiente administración.",
      tituloPdf: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Disposiciones_Modelo_de_Control_Interno.pdf"
    },
    {
      id: 3,
      tituloTexto: "Metodología de Administración de Riesgos",
      descripcion: "El presente documento es adecuado a la Secretaría de Bienestar e Inclusión Social basado de referencias en materia de control interno para su aplicación y mejora continua de las áreas de oportunidad propiciando reducir la probabilidad de ocurrencia de actos de corrupción y actos contrarios a la integridad de los servidores públicos.",
      tituloPdf: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Metodologia_Administracion_de_Riesgos-2025_MS.pdf"
    }
  ]

};

export default cinternoitems;